/**
 *
 */
export default class DsoTools {

  /**
   *
   * @param zip
   * @return {{title: *, value: *}[]}
   */
  static getDsoListByZip(zip) {
    return zipDso.filter(e => e.zip === zip).map(
      (el) => {
        return { title: el.name, value: el.ecn}
      }
    )
  }

  /**
   *
   * @param ecn
   * @return {{title: string, value}|{title: *, value: *}}
   */
  static getDsoByEcn(ecn) {
    const results =  zipDso.filter(e => e.ecn === ecn).map(
      (el) => {
        return { title: el.name, value: el.ecn}
      }
    )

    if(results.length === 0)
      return { title: "unbekannter Netzbetreiber", value: ecn}
    return results[0];
  }

  /**
   * Returns the given ECN responsible for EDA communication
   * @param ecnDso
   * @return {*|string}
   */
  static getEcnUnAliased(ecnDso) {

      // AT008000 E-Netze Stmk
      if (ecnDso === "AT008230")
          return "AT008000";
      if (ecnDso === "AT008200")
          return "AT008000";
      if (ecnDso === "AT008830")
          return "AT008000";
      if (ecnDso === "AT008380")
          return "AT008000";
      if (ecnDso === "AT008480")
          return "AT008000";
      if (ecnDso === "AT008960")
          return "AT008000";
      if (ecnDso === "AT008320")
          return "AT008000";

      // Netz Salzburg
      if (ecnDso === "AT004130")
          return "AT004000";

      // KIENDLER merge 20260701
      if (ecnDso === "AT008580")
          return "AT008630";

      // Netz OÖ Merge
      if (ecnDso === "AT003470")
          return "AT003000";

      return ecnDso;
  }

  /**
   * Detects the DSO for a given community and membership
   * @param community
   * @param membership or ecnDso from it
   * @returns {Promise<string>}
   * @throws Error if ecnDso is not valid or community type is not supported
   */
  static detectDso(community, membership) {
    let membershipEcn = membership; // assume string
    if(typeof membershipEcn === 'object')
      membershipEcn = membershipEcn.ecnDso;

    let ecnDso = community.ecnDso; // 16a, 16c
    if(community.communityType === '16b') {
      ecnDso = membershipEcn;
    }
    if(community.communityType === 'EP') {
      ecnDso = membershipEcn;
      // throw Error("EP not supported for now"); // decline for now since this is a community (16x) process
    }

    if(!DsoTools.isEcnDsoAlike(ecnDso)) {
      throw Error("ecnDso not valid: "+ecnDso);
    }

    // kinda safety to run against de-aliasing
    return DsoTools.getEcnUnAliased(ecnDso);
  }

  static isEcnDsoAlike(ecn) {
    return (/^AT\d{6}$/).test(ecn);
  }
}


const zipDso =
  [
    {
      "zip": "6771",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6773",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6774",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6780",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6781",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6782",
      "nameEca": "Montafonerbahn Aktiengesellschaft",
      "ecn": "AT006220",
      "name": "Montafonerbahn Aktiengesellschaft"
    },
    {
      "zip": "6250",
      "nameEca": "Stadtwerke Wörgl GmbH",
      "ecn": "AT005160",
      "name": "Stadtwerke Wörgl GmbH"
    },
    {
      "zip": "6300",
      "nameEca": "Stadtwerke Wörgl GmbH",
      "ecn": "AT005160",
      "name": "Stadtwerke Wörgl GmbH"
    },
    {
      "zip": "6314",
      "nameEca": "Stadtwerke Wörgl GmbH",
      "ecn": "AT005160",
      "name": "Stadtwerke Wörgl GmbH"
    },
    {
      "zip": "6322",
      "nameEca": "Stadtwerke Wörgl GmbH",
      "ecn": "AT005160",
      "name": "Stadtwerke Wörgl GmbH"
    },
    {
      "zip": "4742",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4743",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4753",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4754",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4772",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4910",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4911",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4912",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4920",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4921",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4923",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4931",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4932",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4941",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4942",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4970",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4971",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4972",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4973",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4982",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "4983",
      "nameEca": "Energie Ried GmbH",
      "ecn": "AT003200",
      "name": "ENERGIE RIED GmbH"
    },
    {
      "zip": "5630",
      "nameEca": "Elektrizitätswerk Bad Hofgastein Gesellschaft m.b.H.",
      "ecn": "AT004110",
      "name": "Elektrizitätswerk Bad Hofgastein"
    },
    {
      "zip": "3334",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "3335",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "3343",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "3352",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4030",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4050",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4052",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4053",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4055",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4060",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4061",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4062",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4063",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4064",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4070",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4072",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4073",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4074",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4075",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4076",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4081",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4082",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4083",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4084",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4085",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4090",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4091",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4092",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4100",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4101",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4102",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4111",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4112",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4113",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4114",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4115",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4116",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4120",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4121",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4122",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4131",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4132",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4133",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4134",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4141",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4142",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4143",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4144",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4150",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4151",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4152",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4153",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4154",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4155",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4160",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4161",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4162",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4163",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4164",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4170",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4171",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4172",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4173",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4174",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4175",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4180",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4181",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4182",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4183",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4184",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4190",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4191",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4201",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4400",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4407",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4421",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4441",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4442",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4443",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4451",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4452",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4453",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4460",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4461",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4462",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4463",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4464",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4470",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4481",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4483",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4484",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4490",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4491",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4492",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4493",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4501",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4502",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4511",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4521",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4522",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4523",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4531",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4532",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4533",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4540",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4541",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4542",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4550",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4551",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4552",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4553",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4554",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4560",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4562",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4563",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4564",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4565",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4571",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4572",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4573",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4574",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4575",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4580",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4581",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4582",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4591",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4592",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4593",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4594",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4595",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4596",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4600",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4611",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4612",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4613",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4614",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4615",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4616",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4621",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4622",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4623",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4624",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4625",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4631",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4632",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4633",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4641",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4642",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4643",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4644",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4645",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4650",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4651",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4652",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4653",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4654",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4655",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4656",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4661",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4662",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4663",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4664",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4671",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4672",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4673",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4674",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4675",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4676",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4680",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4681",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4682",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4690",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4692",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4693",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4694",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4701",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4702",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4707",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4710",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4712",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4713",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4714",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4715",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4716",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4720",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4721",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4722",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4723",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4724",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4725",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4730",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4731",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4732",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4733",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4741",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4742",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4743",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4751",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4752",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4753",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4755",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4760",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4761",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4762",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4770",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4771",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4772",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4773",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4774",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4775",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4776",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4777",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4780",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4782",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4783",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4784",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4785",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4786",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4791",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4792",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4793",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4794",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4800",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4801",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4802",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4810",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4812",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4813",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4814",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4816",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4817",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4820",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4821",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4822",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4823",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4824",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4825",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4830",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4831",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4840",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4841",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4842",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4843",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4844",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4845",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4846",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4849",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4850",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4851",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4852",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4853",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4854",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4860",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4861",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4863",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4864",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4865",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4866",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4870",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4871",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4872",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4873",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4880",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4881",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4882",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4890",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4891",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4892",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4893",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4894",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4901",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4902",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4903",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4904",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4906",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4910",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4920",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4921",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4922",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4923",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4924",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4925",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4926",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4931",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4932",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4933",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4942",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4943",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4950",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4951",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4952",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4961",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4962",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4963",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4973",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4974",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4975",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4980",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4981",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4982",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4983",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "4984",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5113",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5120",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5121",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5122",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5123",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5131",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5132",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5133",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5134",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5141",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5142",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5143",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5144",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5145",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5152",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5163",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5165",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5166",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5204",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5205",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5211",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5212",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5221",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5222",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5223",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5224",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5225",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5230",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5231",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5232",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5233",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5241",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5242",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5251",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5252",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5261",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5270",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5271",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5272",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5273",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5274",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5280",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5282",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5310",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5311",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5350",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5351",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5360",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5441",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5524",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5600",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5611",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5612",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "5621",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8933",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8934",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8982",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8983",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8984",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8990",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8992",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "8993",
      "nameEca": "Netz Oberösterreich GmbH",
      "ecn": "AT003000",
      "name": "Netz Oberösterreich GmbH"
    },
    {
      "zip": "6156",
      "nameEca": "Elektrizitätswerk der Gemeinde Gries am Brenner",
      "ecn": "AT005540",
      "name": "Elektritzitätswerk der Gemeinde Gries am Brenner"
    },
    {
      "zip": "6600",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6604",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6610",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6611",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6621",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6622",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6623",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6631",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6632",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6633",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6642",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6644",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6645",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6646",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6647",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6650",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6651",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6652",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6653",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6654",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6655",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6670",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6671",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "6682",
      "nameEca": "Elektrizitätswerke Reutte AG",
      "ecn": "AT005110",
      "name": "Elektrizitätswerke Reutte AG"
    },
    {
      "zip": "8621",
      "nameEca": "Joh. Pengg Holding Gesellschaft m.b.H.",
      "ecn": "AT008930",
      "name": "Joh. Pengg Holding Gesellschaft m.b.H."
    },
    {
      "zip": "3342",
      "nameEca": "Licht- und Kraftstromvertrieb der Gemeinde Opponitz",
      "ecn": "AT002300",
      "name": "Licht- und Kraftstromvertrieb der Gemeinde Opponitz"
    },
    {
      "zip": "8071",
      "nameEca": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG",
      "ecn": "AT008570",
      "name": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG"
    },
    {
      "zip": "8072",
      "nameEca": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG",
      "ecn": "AT008570",
      "name": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG"
    },
    {
      "zip": "8074",
      "nameEca": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG",
      "ecn": "AT008570",
      "name": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG"
    },
    {
      "zip": "8076",
      "nameEca": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG",
      "ecn": "AT008570",
      "name": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG"
    },
    {
      "zip": "8077",
      "nameEca": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG",
      "ecn": "AT008570",
      "name": "Elektrizitätswerk Fernitz Ing. Franz Purkarthofer GmbH & Co KG"
    },
    {
      "zip": "8544",
      "nameEca": "E-Werk Sigl GmbH & Co. KG",
      "ecn": "AT008540",
      "name": "E-Werk SIGL GmbH & CO KG"
    },
    {
      "zip": "8551",
      "nameEca": "E-Werk Sigl GmbH & Co. KG",
      "ecn": "AT008540",
      "name": "E-Werk SIGL GmbH & CO KG"
    },
    {
      "zip": "8850",
      "nameEca": "Murauer Stadtwerke Gesellschaft m.b.H.",
      "ecn": "AT008430",
      "name": "Murauer Stadtwerke Gesellschaft m.b.H"
    },
    {
      "zip": "8852",
      "nameEca": "Murauer Stadtwerke Gesellschaft m.b.H.",
      "ecn": "AT008430",
      "name": "Murauer Stadtwerke Gesellschaft m.b.H"
    },
    {
      "zip": "8861",
      "nameEca": "Murauer Stadtwerke Gesellschaft m.b.H.",
      "ecn": "AT008430",
      "name": "Murauer Stadtwerke Gesellschaft m.b.H"
    },
    {
      "zip": "6150",
      "nameEca": "E-Werk Ingrid Reinisch",
      "ecn": "AT005690",
      "name": "E-Werk Ingrid Reinisch"
    },
    {
      "zip": "8152",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8563",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8564",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8565",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8570",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8572",
      "nameEca": "Stadtwerke Voitsberg GmbH",
      "ecn": "AT008120",
      "name": "Stadtwerke Voitsberg GmbH"
    },
    {
      "zip": "8343",
      "nameEca": "Bad Gleichenberger Energie GmbH",
      "ecn": "AT008310",
      "name": "Bad Gleichenberger Energie GmbH"
    },
    {
      "zip": "8344",
      "nameEca": "Bad Gleichenberger Energie GmbH",
      "ecn": "AT008310",
      "name": "Bad Gleichenberger Energie GmbH"
    },
    {
      "zip": "8353",
      "nameEca": "Bad Gleichenberger Energie GmbH",
      "ecn": "AT008310",
      "name": "Bad Gleichenberger Energie GmbH"
    },
    {
      "zip": "8634",
      "nameEca": "Elektrizitätswerk Mürzsteg",
      "ecn": "AT008370",
      "name": "E-Werk Mürzsteg"
    },
    {
      "zip": "8692",
      "nameEca": "Elektrizitätswerk Mürzsteg",
      "ecn": "AT008370",
      "name": "E-Werk Mürzsteg"
    },
    {
      "zip": "8693",
      "nameEca": "Elektrizitätswerk Mürzsteg",
      "ecn": "AT008370",
      "name": "E-Werk Mürzsteg"
    },
    {
      "zip": "5661",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "8554",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "8742",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "8820",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "8822",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "8864",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9020",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9061",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9062",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9063",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9064",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9065",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9071",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9072",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9073",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9074",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9081",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9082",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9100",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9102",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9103",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9104",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9111",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9112",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9113",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9121",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9122",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9123",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9125",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9130",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9131",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9132",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9133",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9135",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9141",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9142",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9143",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9150",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9155",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9161",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9162",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9163",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9170",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9173",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9181",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9182",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9183",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9184",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9201",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9210",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9212",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9220",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9231",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9232",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9241",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9300",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9311",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9312",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9313",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9314",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9321",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9322",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9323",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9330",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9334",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9335",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9341",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9342",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9343",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9344",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9345",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9346",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9360",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9361",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9362",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9363",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9371",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9372",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9373",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9374",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9375",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9376",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9400",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9411",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9412",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9413",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9421",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9422",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9423",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9431",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9433",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9441",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9451",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9461",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9462",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9463",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9470",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9472",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9473",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9500",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9504",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9520",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9521",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9523",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9524",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9530",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9531",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9535",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9536",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9541",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9542",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9543",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9544",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9545",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9546",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9551",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9552",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9554",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9555",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9556",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9560",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9562",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9563",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9564",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9565",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9570",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9571",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9572",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9580",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9581",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9582",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9583",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9584",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9585",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9586",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9587",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9601",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9602",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9611",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9612",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9613",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9614",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9615",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9620",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9622",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9623",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9624",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9631",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9632",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9633",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9634",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9635",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9640",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9651",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9652",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9653",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9654",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9655",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9701",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9702",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9710",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9711",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9712",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9713",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9714",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9721",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9722",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9751",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9753",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9754",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9761",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9762",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9771",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9772",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9773",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9781",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9800",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9803",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9805",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9811",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9812",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9813",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9814",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9815",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9816",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9821",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9822",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9831",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9832",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9833",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9841",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9842",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9843",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9844",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9851",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9852",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9853",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9854",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9861",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9862",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9863",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9871",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9872",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "9873",
      "nameEca": "KNG-Kärnten Netz GmbH",
      "ecn": "AT007000",
      "name": "KNG-Kärnten Netz GmbH"
    },
    {
      "zip": "6060",
      "nameEca": "HALLAG Kommunal GmbH",
      "ecn": "AT005120",
      "name": "HALLAG Kommunal GmbH"
    },
    {
      "zip": "6067",
      "nameEca": "HALLAG Kommunal GmbH",
      "ecn": "AT005120",
      "name": "HALLAG Kommunal GmbH"
    },
    {
      "zip": "6068",
      "nameEca": "HALLAG Kommunal GmbH",
      "ecn": "AT005120",
      "name": "HALLAG Kommunal GmbH"
    },
    {
      "zip": "6111",
      "nameEca": "HALLAG Kommunal GmbH",
      "ecn": "AT005120",
      "name": "HALLAG Kommunal GmbH"
    },
    {
      "zip": "6580",
      "nameEca": "EWA Energie- und Wirtschaftsbetriebe der Gemeinde St. Anton GmbH",
      "ecn": "AT005320",
      "name": "Energie und Wirtschaftsbetriebe der Gemeinde St. Anton GmbH"
    },
    {
      "zip": "6311",
      "nameEca": "E-Werk Stadler GmbH",
      "ecn": "AT005470",
      "name": "E-Werk Stadler GmbH"
    },
    {
      "zip": "6313",
      "nameEca": "E-Werk Stadler GmbH",
      "ecn": "AT005470",
      "name": "E-Werk Stadler GmbH"
    },
    {
      "zip": "8954",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "8960",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "8961",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "8962",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "8965",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "8966",
      "nameEca": "Elektrizitätswerk Gröbming KG.",
      "ecn": "AT008620",
      "name": "E-Werk Gröbming KG"
    },
    {
      "zip": "4644",
      "nameEca": "E-Werk Redlmühle Bernhard Drack",
      "ecn": "AT003910",
      "name": "E-Werk Redlmühle / Verteilnetzbetrieb"
    },
    {
      "zip": "4645",
      "nameEca": "E-Werk Redlmühle Bernhard Drack",
      "ecn": "AT003910",
      "name": "E-Werk Redlmühle / Verteilnetzbetrieb"
    },
    {
      "zip": "6330",
      "nameEca": "Stadtwerke Kufstein GmbH",
      "ecn": "AT005140",
      "name": "Stadtwerke Kufstein Gesellschaft m.b.H."
    },
    {
      "zip": "6334",
      "nameEca": "Stadtwerke Kufstein GmbH",
      "ecn": "AT005140",
      "name": "Stadtwerke Kufstein Gesellschaft m.b.H."
    },
    {
      "zip": "6335",
      "nameEca": "Stadtwerke Kufstein GmbH",
      "ecn": "AT005140",
      "name": "Stadtwerke Kufstein Gesellschaft m.b.H."
    },
    {
      "zip": "6336",
      "nameEca": "Stadtwerke Kufstein GmbH",
      "ecn": "AT005140",
      "name": "Stadtwerke Kufstein Gesellschaft m.b.H."
    },
    {
      "zip": "6341",
      "nameEca": "Stadtwerke Kufstein GmbH",
      "ecn": "AT005140",
      "name": "Stadtwerke Kufstein Gesellschaft m.b.H."
    },
    {
      "zip": "6115",
      "nameEca": "Elektrizitätswerk Winkler GmbH",
      "ecn": "AT005480",
      "name": "Elektrizitätswerk Winkler GmbH"
    },
    {
      "zip": "6133",
      "nameEca": "Elektrizitätswerk Winkler GmbH",
      "ecn": "AT005480",
      "name": "Elektrizitätswerk Winkler GmbH"
    },
    {
      "zip": "6133",
      "nameEca": "Elektrogenossenschaft Weerberg reg.Gen.m.b.H.",
      "ecn": "AT005630",
      "name": "Elektrogenossenschaft Weerberg reg.genmbH"
    },
    {
      "zip": "8673",
      "nameEca": "Andreas Braunstein",
      "ecn": "AT008550",
      "name": "Andreas Braunstein"
    },
    {
      "zip": "8674",
      "nameEca": "Andreas Braunstein",
      "ecn": "AT008550",
      "name": "Andreas Braunstein"
    },
    {
      "zip": "8960",
      "nameEca": "Mag. Engelbert Tassotti E-Werk und EVU",
      "ecn": "AT008990",
      "name": "Mag. Engelbert Tassotti E-Werk und EVU"
    },
    {
      "zip": "8961",
      "nameEca": "Mag. Engelbert Tassotti E-Werk und EVU",
      "ecn": "AT008990",
      "name": "Mag. Engelbert Tassotti E-Werk und EVU"
    },
    {
      "zip": "8082",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8083",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8092",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8403",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8413",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8421",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8422",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "8424",
      "nameEca": "P.K. Energieversorgungs-GmbH",
      "ecn": "AT008630",
      "name": "P.K. Energieversorgungs-GmbH (kiendler E-Werk)"
    },
    {
      "zip": "4643",
      "nameEca": "E-Werk Ranklleiten",
      "ecn": "AT003590",
      "name": "E-Werk Ranklleiten"
    },
    {
      "zip": "4644",
      "nameEca": "E-Werk Ranklleiten",
      "ecn": "AT003590",
      "name": "E-Werk Ranklleiten"
    },
    {
      "zip": "2413",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2421",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2422",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2423",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2424",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2425",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2443",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2460",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2462",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2471",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2473",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2474",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2475",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2485",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "2491",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7000",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7011",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7012",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7013",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7020",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7021",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7022",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7023",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7024",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7025",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7031",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7032",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7033",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7034",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7035",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7041",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7042",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7051",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7052",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7053",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7061",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7062",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7063",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7064",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7071",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7072",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7081",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7082",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7083",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7091",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7092",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7093",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7100",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7111",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7121",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7122",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7123",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7131",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7132",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7141",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7142",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7143",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7151",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7152",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7161",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7162",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7163",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7201",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7202",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7203",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7210",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7212",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7221",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7222",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7223",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7301",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7302",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7304",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7311",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7312",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7321",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7322",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7323",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7331",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7332",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7341",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7342",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7343",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7344",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7350",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7361",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7371",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7372",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7373",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7374",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7400",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7410",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7411",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7412",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7422",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7423",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7425",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7431",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7432",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7433",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7434",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7435",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7441",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7442",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7443",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7444",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7451",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7452",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7453",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7461",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7463",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7464",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7471",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7472",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7473",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7474",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7501",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7502",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7503",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7511",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7512",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7521",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7522",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7531",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7532",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7533",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7534",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7535",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7536",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7537",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7540",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7542",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7543",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7544",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7545",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7546",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7550",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7551",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7552",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7553",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7554",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7561",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7562",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7563",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7564",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7571",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7572",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "7574",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8291",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8292",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8293",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8350",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8380",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8382",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8383",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8384",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "8385",
      "nameEca": "Netz Burgenland GmbH",
      "ecn": "AT009000",
      "name": "Netz Burgenland GmbH"
    },
    {
      "zip": "1010",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1020",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1030",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1040",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1050",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1060",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1070",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1080",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1090",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1100",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1110",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1120",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1130",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1140",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1150",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1160",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1170",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1180",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1190",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1200",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1210",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1220",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "1230",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2100",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2102",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2103",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2201",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2202",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2280",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2281",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2282",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2301",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2304",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2320",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2322",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2325",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2326",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2331",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2332",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2333",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2334",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2340",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2344",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2345",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2351",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2352",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2353",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2361",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2362",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2371",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2372",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2380",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2381",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2384",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2391",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2392",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2393",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2401",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2431",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2432",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2435",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2440",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2441",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2442",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2481",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2482",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2483",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2486",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2490",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2491",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2492",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2493",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2500",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2504",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2511",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2512",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2514",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2521",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2522",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2523",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2524",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2525",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2531",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2540",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2542",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2544",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2551",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2552",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2601",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2603",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "2751",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3001",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3002",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3003",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3011",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3012",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3264",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3292",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3293",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3341",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3342",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3343",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3344",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3345",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3400",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3420",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3421",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "3423",
      "nameEca": "Wiener Netze GmbH",
      "ecn": "AT001000",
      "name": "Wiener Netze GmbH"
    },
    {
      "zip": "8600",
      "nameEca": "Stadtwerke Bruck an der Mur GmbH",
      "ecn": "AT008140",
      "name": "Stadtwerke Bruck an der Mur GmbH"
    },
    {
      "zip": "8605",
      "nameEca": "Stadtwerke Bruck an der Mur GmbH",
      "ecn": "AT008140",
      "name": "Stadtwerke Bruck an der Mur GmbH"
    },
    {
      "zip": "8811",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "8812",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "8813",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "8820",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "8831",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "8833",
      "nameEca": "Elektrizitätswerk Mariahof GmbH",
      "ecn": "AT008650",
      "name": "Elektrizitätswerk Mariahof GmbH"
    },
    {
      "zip": "3343",
      "nameEca": "Licht- und Kraftvertrieb der Gemeinde Hollenstein an der Ybbs",
      "ecn": "AT002130",
      "name": "Licht- und Kraftvertrieb der Gemeinde Hollenstein an der Ybbs"
    },
    {
      "zip": "6370",
      "nameEca": "Stadtwerke Kitzbühel",
      "ecn": "AT005130",
      "name": "Stadtwerke Kitzbühel e.U."
    },
    {
      "zip": "8911",
      "nameEca": "Envesta Energie- und Dienstleistungs GmbH",
      "ecn": "AT008560",
      "name": "ENVESTA Energie- u. Dienstleistungs GmbH"
    },
    {
      "zip": "8912",
      "nameEca": "Envesta Energie- und Dienstleistungs GmbH",
      "ecn": "AT008560",
      "name": "ENVESTA Energie- u. Dienstleistungs GmbH"
    },
    {
      "zip": "8913",
      "nameEca": "Envesta Energie- und Dienstleistungs GmbH",
      "ecn": "AT008560",
      "name": "ENVESTA Energie- u. Dienstleistungs GmbH"
    },
    {
      "zip": "8443",
      "nameEca": "E-Werk Gleinstätten GmbH",
      "ecn": "AT008740",
      "name": "E-Werk Gleinstätten GmbH"
    },
    {
      "zip": "9961",
      "nameEca": "Elektrowerkgenossenschaft Hopfgarten i. D. reg.Gen.m.b.H.",
      "ecn": "AT005600",
      "name": "Elektrowerkgenossenschaft Hopfgarten i. D. reg. Gen.m.b.H."
    },
    {
      "zip": "2431",
      "nameEca": "Polsterer Kerres Ruttin Holding GmbH",
      "ecn": "AT002270",
      "name": "Polsterer Kerres Ruttin Holding GmbH"
    },
    {
      "zip": "4310",
      "nameEca": "Elektrizitätswerk Perg GmbH",
      "ecn": "AT003310",
      "name": "Elektrizitätswerk Perg GmbH"
    },
    {
      "zip": "4311",
      "nameEca": "Elektrizitätswerk Perg GmbH",
      "ecn": "AT003310",
      "name": "Elektrizitätswerk Perg GmbH"
    },
    {
      "zip": "4320",
      "nameEca": "Elektrizitätswerk Perg GmbH",
      "ecn": "AT003310",
      "name": "Elektrizitätswerk Perg GmbH"
    },
    {
      "zip": "4322",
      "nameEca": "Elektrizitätswerk Perg GmbH",
      "ecn": "AT003310",
      "name": "Elektrizitätswerk Perg GmbH"
    },
    {
      "zip": "4323",
      "nameEca": "Elektrizitätswerk Perg GmbH",
      "ecn": "AT003310",
      "name": "Elektrizitätswerk Perg GmbH"
    },
    {
      "zip": "6700",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6706",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6707",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6708",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6710",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6712",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6713",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6714",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6719",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6721",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6722",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6723",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6731",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6733",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6741",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6751",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6752",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6754",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6762",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6763",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6764",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6767",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6771",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6773",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6774",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6780",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6781",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6787",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6791",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6793",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6794",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6811",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6812",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6820",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6822",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6824",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6830",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6832",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6833",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6834",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6835",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6836",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6837",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6840",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6841",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6842",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6844",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6845",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6850",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6858",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6861",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6863",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6866",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6867",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6870",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6874",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6881",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6882",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6883",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6884",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6886",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6888",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6890",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6900",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6911",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6912",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6914",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6921",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6922",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6923",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6932",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6933",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6934",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6941",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6942",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6943",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6951",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6952",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6960",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6971",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6972",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6973",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "6974",
      "nameEca": "Vorarlberger Energienetze GmbH",
      "ecn": "AT006000",
      "name": "Vorarlberger Energienetze GmbH"
    },
    {
      "zip": "9020",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9061",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9063",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9064",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9065",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9073",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9081",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9130",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9131",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9201",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "9210",
      "nameEca": "Energie Klagenfurt GmbH",
      "ecn": "AT007100",
      "name": "Energie Klagenfurt GmbH"
    },
    {
      "zip": "6800",
      "nameEca": "Stadtwerke Feldkirch",
      "ecn": "AT006110",
      "name": "Stadtwerke Feldkirch"
    },
    {
      "zip": "6820",
      "nameEca": "Elektrizitätswerke Frastanz Gesellschaft m.b.H.",
      "ecn": "AT006210",
      "name": "Elektrizitätswerke Frastanz Gesellschaft mbH"
    },
    {
      "zip": "8786",
      "nameEca": "Städtische Betriebe Rottenmann GmbH",
      "ecn": "AT008350",
      "name": "Städtische Betriebe Rottenmann GmbH"
    },
    {
      "zip": "2640",
      "nameEca": "Elektrizitätswerke Eisenhuber GmbH & Co KG",
      "ecn": "AT002210",
      "name": "Elektrizitätswerke Eisenhuber GmbH & Co KG"
    },
    {
      "zip": "2873",
      "nameEca": "Elektrizitätswerke Eisenhuber GmbH & Co KG",
      "ecn": "AT002210",
      "name": "Elektrizitätswerke Eisenhuber GmbH & Co KG"
    },
    {
      "zip": "2880",
      "nameEca": "Elektrizitätswerke Eisenhuber GmbH & Co KG",
      "ecn": "AT002210",
      "name": "Elektrizitätswerke Eisenhuber GmbH & Co KG"
    },
    {
      "zip": "2881",
      "nameEca": "Elektrizitätswerke Eisenhuber GmbH & Co KG",
      "ecn": "AT002210",
      "name": "Elektrizitätswerke Eisenhuber GmbH & Co KG"
    },
    {
      "zip": "8490",
      "nameEca": "Elektrizitätswerke Bad Radkersburg GmbH",
      "ecn": "AT008450",
      "name": "Elektrizitätswerke Bad Radkersburg GmbH"
    },
    {
      "zip": "2852",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "2871",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "2872",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "7423",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "7425",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8063",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8076",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8081",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8181",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8182",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8183",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8184",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8190",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8192",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8200",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8211",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8212",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8221",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8222",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8223",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8224",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8225",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8230",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8232",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8233",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8234",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8240",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8241",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8242",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8243",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8244",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8250",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8251",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8252",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8253",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8254",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8255",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8261",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8262",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8264",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8265",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8271",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8272",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8273",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8274",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8283",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8293",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8294",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8295",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8301",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8302",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8311",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8312",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8321",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8323",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8673",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "8674",
      "nameEca": "Feistritzwerke-STEWEAG GmbH",
      "ecn": "AT008130",
      "name": "Feistritzwerke Steweag GmbH"
    },
    {
      "zip": "4122",
      "nameEca": "Energieversorgungs GmbH",
      "ecn": "AT003580",
      "name": "Energieversorgungs GmbH"
    },
    {
      "zip": "4171",
      "nameEca": "Energieversorgungs GmbH",
      "ecn": "AT003580",
      "name": "Energieversorgungs GmbH"
    },
    {
      "zip": "6112",
      "nameEca": "Kraftwerk Haim KG",
      "ecn": "AT005210",
      "name": "Kraftwerk Haim KG"
    },
    {
      "zip": "6113",
      "nameEca": "Kraftwerk Haim KG",
      "ecn": "AT005210",
      "name": "Kraftwerk Haim KG"
    },
    {
      "zip": "6114",
      "nameEca": "Kraftwerk Haim KG",
      "ecn": "AT005210",
      "name": "Kraftwerk Haim KG"
    },
    {
      "zip": "6115",
      "nameEca": "Kraftwerk Haim KG",
      "ecn": "AT005210",
      "name": "Kraftwerk Haim KG"
    },
    {
      "zip": "6116",
      "nameEca": "Kraftwerk Haim KG",
      "ecn": "AT005210",
      "name": "Kraftwerk Haim KG"
    },
    {
      "zip": "8741",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8742",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8750",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8753",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8754",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8755",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8756",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8761",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8762",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "8763",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "9463",
      "nameEca": "Stadtwerke Judenburg AG",
      "ecn": "AT008160",
      "name": "Stadtwerke Judenburg AG"
    },
    {
      "zip": "9640",
      "nameEca": "AAE Wasserkraft Gesellschaft m.b.H.",
      "ecn": "AT007240",
      "name": "AAE Wasserkraft GmbH"
    },
    {
      "zip": "2000",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2002",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2003",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2004",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2011",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2013",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2014",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2020",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2022",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2023",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2024",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2031",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2032",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2033",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2034",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2041",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2042",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2051",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2052",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2053",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2054",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2061",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2062",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2063",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2064",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2070",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2073",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2074",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2081",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2082",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2083",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2084",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2091",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2092",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2093",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2094",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2095",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2100",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2102",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2104",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2105",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2111",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2112",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2113",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2114",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2115",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2116",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2120",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2122",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2123",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2124",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2125",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2126",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2130",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2132",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2133",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2134",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2135",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2136",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2141",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2143",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2144",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2145",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2151",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2152",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2153",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2154",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2161",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2162",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2163",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2164",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2165",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2170",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2171",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2172",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2181",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2182",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2183",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2184",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2185",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2191",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2192",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2193",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2201",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2203",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2211",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2212",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2213",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2214",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2215",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2221",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2222",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2223",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2224",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2225",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2230",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2231",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2232",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2241",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2242",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2243",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2244",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2245",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2251",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2252",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2253",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2261",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2262",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2263",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2264",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2265",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2272",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2273",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2274",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2275",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2276",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2281",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2282",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2283",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2284",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2285",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2286",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2291",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2292",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2293",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2294",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2295",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2301",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2304",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2305",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2331",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2340",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2344",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2351",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2371",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2381",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2401",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2402",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2403",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2404",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2405",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2410",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2412",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2413",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2431",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2432",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2433",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2434",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2443",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2444",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2451",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2452",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2453",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2454",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2460",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2462",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2463",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2464",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2465",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2471",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2472",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2473",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2485",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2486",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2492",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2493",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2500",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2512",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2514",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2523",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2524",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2525",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2532",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2533",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2534",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2540",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2542",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2560",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2561",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2563",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2564",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2565",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2571",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2572",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2601",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2602",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2603",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2604",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2620",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2624",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2625",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2630",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2631",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2632",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2640",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2641",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2642",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2650",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2651",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2654",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2661",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2662",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2663",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2671",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2673",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2680",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2700",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2721",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2722",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2723",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2724",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2731",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2732",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2733",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2734",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2751",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2752",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2753",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2754",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2755",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2761",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2763",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2770",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2801",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2802",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2803",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2811",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2812",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2813",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2821",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2822",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2823",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2824",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2831",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2832",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2833",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2840",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2842",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2851",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2852",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2853",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2860",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2870",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2871",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2872",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2873",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2880",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "2881",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3001",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3003",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3004",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3011",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3012",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3013",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3021",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3031",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3032",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3033",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3034",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3040",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3041",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3042",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3051",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3052",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3053",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3061",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3062",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3071",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3072",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3073",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3074",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3100",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3104",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3105",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3107",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3110",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3121",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3122",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3123",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3124",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3125",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3130",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3131",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3133",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3134",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3140",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3141",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3142",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3143",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3144",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3150",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3151",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3153",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3160",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3161",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3162",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3163",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3170",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3171",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3172",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3180",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3183",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3184",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3192",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3193",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3195",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3200",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3202",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3203",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3204",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3205",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3211",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3212",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3213",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3214",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3221",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3222",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3223",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3224",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3231",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3232",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3233",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3240",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3241",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3242",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3243",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3244",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3250",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3251",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3252",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3253",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3254",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3261",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3262",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3263",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3264",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3270",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3281",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3282",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3283",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3291",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3292",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3293",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3294",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3295",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3300",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3304",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3311",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3312",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3313",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3314",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3321",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3322",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3323",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3324",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3325",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3331",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3332",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3333",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3334",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3340",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3341",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3343",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3345",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3350",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3351",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3352",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3353",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3354",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3355",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3361",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3362",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3363",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3364",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3365",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3370",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3371",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3372",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3373",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3374",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3375",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3376",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3380",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3381",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3382",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3383",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3384",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3385",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3386",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3390",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3392",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3393",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3394",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3400",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3413",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3422",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3423",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3424",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3425",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3426",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3430",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3433",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3434",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3435",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3441",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3442",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3443",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3451",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3452",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3454",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3462",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3463",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3464",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3465",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3470",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3471",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3472",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3473",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3474",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3481",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3482",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3483",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3484",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3485",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3491",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3492",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3493",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3494",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3495",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3500",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3506",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3508",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3511",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3512",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3521",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3522",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3524",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3525",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3531",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3532",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3533",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3541",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3542",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3543",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3544",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3550",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3552",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3553",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3561",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3562",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3564",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3571",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3572",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3573",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3580",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3591",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3592",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3593",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3594",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3595",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3601",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3602",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3610",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3611",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3613",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3620",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3621",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3622",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3623",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3631",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3632",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3633",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3641",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3642",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3643",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3644",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3650",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3652",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3653",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3654",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3660",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3661",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3662",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3663",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3664",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3665",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3671",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3672",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3680",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3681",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3683",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3684",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3691",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3701",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3702",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3704",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3710",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3711",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3712",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3713",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3714",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3720",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3721",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3722",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3730",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3741",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3742",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3743",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3744",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3751",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3752",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3753",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3754",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3761",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3762",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3763",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3800",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3804",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3811",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3812",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3813",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3814",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3820",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3822",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3823",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3824",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3830",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3834",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3841",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3842",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3843",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3844",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3851",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3852",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3860",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3861",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3862",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3863",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3871",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3872",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3873",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3874",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3900",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3902",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3903",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3910",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3911",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3912",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3913",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3914",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3920",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3921",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3922",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3923",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3924",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3925",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3931",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3932",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3942",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3943",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3944",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3945",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3950",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3961",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3962",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3970",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3971",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3972",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "3973",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4252",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4280",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4300",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4303",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4372",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4392",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4431",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4432",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4441",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4442",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4443",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "4482",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "7053",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "7421",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "7432",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "7434",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8243",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8244",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8630",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8632",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8685",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8694",
      "nameEca": "Netz Niederösterreich GmbH",
      "ecn": "AT002000",
      "name": "Netz Niederösterreich GmbH"
    },
    {
      "zip": "8230",
      "nameEca": "Stadtwerke Hartberg Energieversorgungs GmbH",
      "ecn": "AT008470",
      "name": "Stadtwerke Hartberg Energieversorgungs GmbH"
    },
    {
      "zip": "8232",
      "nameEca": "Stadtwerke Hartberg Energieversorgungs GmbH",
      "ecn": "AT008470",
      "name": "Stadtwerke Hartberg Energieversorgungs GmbH"
    },
    {
      "zip": "8295",
      "nameEca": "Stadtwerke Hartberg Energieversorgungs GmbH",
      "ecn": "AT008470",
      "name": "Stadtwerke Hartberg Energieversorgungs GmbH"
    },
    {
      "zip": "7522",
      "nameEca": "Energie Güssing GmbH",
      "ecn": "AT009220",
      "name": "Energie Güssing GmbH"
    },
    {
      "zip": "7540",
      "nameEca": "Energie Güssing GmbH",
      "ecn": "AT009220",
      "name": "Energie Güssing GmbH"
    },
    {
      "zip": "7545",
      "nameEca": "Energie Güssing GmbH",
      "ecn": "AT009220",
      "name": "Energie Güssing GmbH"
    },
    {
      "zip": "6460",
      "nameEca": "Stadtgemeinde Imst, Inhaberin der nicht prot. Fa. \"Stadtwerke Imst\"",
      "ecn": "AT005370",
      "name": "Stadtwerke Imst"
    },
    {
      "zip": "8552",
      "nameEca": "Marktgemeinde Eibiswald",
      "ecn": "AT008390",
      "name": "Elektroversorgungsunternehmen der Marktgemeinde Eibiswald"
    },
    {
      "zip": "6700",
      "nameEca": "Getzner, Mutter & Cie. Gesellschaft m.b.H. & Co. KG",
      "ecn": "AT006240",
      "name": "Getzner, Mutter & Cie. GmbH & Co KG"
    },
    {
      "zip": "6706",
      "nameEca": "Getzner, Mutter & Cie. Gesellschaft m.b.H. & Co. KG",
      "ecn": "AT006240",
      "name": "Getzner, Mutter & Cie. GmbH & Co KG"
    },
    {
      "zip": "6710",
      "nameEca": "Getzner, Mutter & Cie. Gesellschaft m.b.H. & Co. KG",
      "ecn": "AT006240",
      "name": "Getzner, Mutter & Cie. GmbH & Co KG"
    },
    {
      "zip": "8630",
      "nameEca": "Stadtbetriebe Mariazell Ges.m.b.H.",
      "ecn": "AT008440",
      "name": "Stadtbetriebe Mariazell GmbH"
    },
    {
      "zip": "8632",
      "nameEca": "Stadtbetriebe Mariazell Ges.m.b.H.",
      "ecn": "AT008440",
      "name": "Stadtbetriebe Mariazell GmbH"
    },
    {
      "zip": "8634",
      "nameEca": "Stadtbetriebe Mariazell Ges.m.b.H.",
      "ecn": "AT008440",
      "name": "Stadtbetriebe Mariazell GmbH"
    },
    {
      "zip": "8635",
      "nameEca": "Stadtbetriebe Mariazell Ges.m.b.H.",
      "ecn": "AT008440",
      "name": "Stadtbetriebe Mariazell GmbH"
    },
    {
      "zip": "8636",
      "nameEca": "Stadtbetriebe Mariazell Ges.m.b.H.",
      "ecn": "AT008440",
      "name": "Stadtbetriebe Mariazell GmbH"
    },
    {
      "zip": "6200",
      "nameEca": "Elektrizitätswerk Prantl Gesellschaft m.b.H. & Co KG",
      "ecn": "AT005460",
      "name": "Elektrizitätswerk Prantl GmbH&CoKG"
    },
    {
      "zip": "4111",
      "nameEca": "KARLSTROM e.U.",
      "ecn": "AT003470",
      "name": "KARLSTROM e.U."
    },
    {
      "zip": "4112",
      "nameEca": "KARLSTROM e.U.",
      "ecn": "AT003470",
      "name": "KARLSTROM e.U."
    },
    {
      "zip": "4201",
      "nameEca": "KARLSTROM e.U.",
      "ecn": "AT003470",
      "name": "KARLSTROM e.U."
    },
    {
      "zip": "4161",
      "nameEca": "E-Werk Dietrichschlag eGen",
      "ecn": "AT003920",
      "name": "E-Werk Dietrichschlag eingetragene Genossenschaft"
    },
    {
      "zip": "8263",
      "nameEca": "Feistritzthaler Elektrizitätswerk eGen",
      "ecn": "AT008770",
      "name": "Feistritzthaler Elektrizitätswerk eGen"
    },
    {
      "zip": "8283",
      "nameEca": "Feistritzthaler Elektrizitätswerk eGen",
      "ecn": "AT008770",
      "name": "Feistritzthaler Elektrizitätswerk eGen"
    },
    {
      "zip": "8362",
      "nameEca": "Feistritzthaler Elektrizitätswerk eGen",
      "ecn": "AT008770",
      "name": "Feistritzthaler Elektrizitätswerk eGen"
    },
    {
      "zip": "6175",
      "nameEca": "Gemeinde Kematen",
      "ecn": "AT005350",
      "name": "Gemeindewerke Kematen"
    },
    {
      "zip": "8223",
      "nameEca": "E-Werk Stubenberg registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008910",
      "name": "E-Werk Stubenberg eGen"
    },
    {
      "zip": "8224",
      "nameEca": "E-Werk Stubenberg registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008910",
      "name": "E-Werk Stubenberg eGen"
    },
    {
      "zip": "8700",
      "nameEca": "Elektrizitätsgenossenschaft Laintal registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008510",
      "name": "E-Genossenschaft Laintal eGen"
    },
    {
      "zip": "8712",
      "nameEca": "Elektrizitätsgenossenschaft Laintal registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008510",
      "name": "E-Genossenschaft Laintal eGen"
    },
    {
      "zip": "8792",
      "nameEca": "Elektrizitätsgenossenschaft Laintal registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008510",
      "name": "E-Genossenschaft Laintal eGen"
    },
    {
      "zip": "8793",
      "nameEca": "Elektrizitätsgenossenschaft Laintal registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008510",
      "name": "E-Genossenschaft Laintal eGen"
    },
    {
      "zip": "8794",
      "nameEca": "Elektrizitätsgenossenschaft Laintal registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT008510",
      "name": "E-Genossenschaft Laintal eGen"
    },
    {
      "zip": "8280",
      "nameEca": "Stadtwerke Fürstenfeld GmbH",
      "ecn": "AT008150",
      "name": "Stadtwerke Fürstenfeld GmbH"
    },
    {
      "zip": "9143",
      "nameEca": "Kraut E-Werk KG",
      "ecn": "AT008970",
      "name": "Kraut E- Werk KG"
    },
    {
      "zip": "6020",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6063",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6071",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6072",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6073",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6080",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6082",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6141",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6161",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "6162",
      "nameEca": "Innsbrucker Kommunalbetriebe AG",
      "ecn": "AT005100",
      "name": "Innsbrucker Kommunalbetriebe Aktiengesellschaft"
    },
    {
      "zip": "4824",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "4825",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "4894",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5020",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5023",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5026",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5061",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5071",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5081",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5082",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5083",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5084",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5090",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5091",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5092",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5093",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5101",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5102",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5110",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5111",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5112",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5113",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5114",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5120",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5151",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5152",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5161",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5162",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5163",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5164",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5165",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5201",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5202",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5203",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5204",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5205",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5300",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5301",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5302",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5303",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5310",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5311",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5321",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5322",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5323",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5324",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5325",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5330",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5340",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5342",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5350",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5360",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5400",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5411",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5412",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5421",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5422",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5423",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5424",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5425",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5431",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5440",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5441",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5442",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5450",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5451",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5452",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5453",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5500",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5505",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5511",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5521",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5522",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5523",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5524",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5531",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5532",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5541",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5542",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5550",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5552",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5561",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5562",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5563",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5570",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5571",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5572",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5573",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5574",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5575",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5580",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5581",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5582",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5583",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5584",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5585",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5591",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5592",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5600",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5602",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5603",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5611",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5620",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5621",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5622",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5630",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5632",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5640",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5645",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5651",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5652",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5660",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5661",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5662",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5671",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5672",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5700",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5710",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5721",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5722",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5723",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5724",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5730",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5731",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5732",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5733",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5741",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5742",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5743",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5751",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5752",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5753",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5754",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5760",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5761",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "5771",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "6281",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "6384",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "8863",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "8864",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "8974",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "9862",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "9863",
      "nameEca": "Salzburg Netz GmbH",
      "ecn": "AT004000",
      "name": "Salzburg Netz GmbH"
    },
    {
      "zip": "6063",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6065",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6067",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6068",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6069",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6070",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6071",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6074",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6075",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6082",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6083",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6091",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6092",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6094",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6095",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6100",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6103",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6105",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6108",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6111",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6112",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6113",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6114",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6115",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6121",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6122",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6123",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6133",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6134",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6135",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6136",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6141",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6142",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6143",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6145",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6150",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6152",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6154",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6156",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6157",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6161",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6165",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6166",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6167",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6170",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6173",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6175",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6176",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6178",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6179",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6181",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6182",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6183",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6184",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6200",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6210",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6212",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6213",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6215",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6220",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6222",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6230",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6232",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6233",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6234",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6235",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6236",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6240",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6241",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6250",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6252",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6260",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6261",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6262",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6263",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6264",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6265",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6271",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6272",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6273",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6274",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6275",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6276",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6277",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6278",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6280",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6281",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6283",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6284",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6290",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6292",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6293",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6294",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6295",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6300",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6305",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6306",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6311",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6313",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6314",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6320",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6321",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6322",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6323",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6324",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6334",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6335",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6336",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6341",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6342",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6343",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6344",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6345",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6346",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6347",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6351",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6352",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6353",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6361",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6363",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6364",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6365",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6370",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6371",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6372",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6373",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6380",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6382",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6383",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6384",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6385",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6391",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6392",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6393",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6395",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6401",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6402",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6403",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6404",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6405",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6406",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6408",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6410",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6413",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6414",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6416",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6421",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6422",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6423",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6424",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6425",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6426",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6430",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6432",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6433",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6441",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6444",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6450",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6452",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6456",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6458",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6460",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6462",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6463",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6464",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6465",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6471",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6473",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6474",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6481",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6491",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6492",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6493",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6500",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6511",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6521",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6522",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6524",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6525",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6526",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6527",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6528",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6531",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6532",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6533",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6534",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6541",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6542",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6543",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6544",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6551",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6552",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6553",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6555",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6561",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6562",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6563",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6571",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6572",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6574",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6580",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "6591",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9782",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9900",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9903",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9904",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9905",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9906",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9907",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9908",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9909",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9911",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9912",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9913",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9918",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9919",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9920",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9931",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9932",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9941",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9942",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9943",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9951",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9952",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9953",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9954",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9961",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9962",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9963",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9971",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9972",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9974",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9981",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9990",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9991",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "9992",
      "nameEca": "TINETZ-Tiroler Netze GmbH",
      "ecn": "AT005000",
      "name": "TINETZ-Tiroler Netze GmbH"
    },
    {
      "zip": "5741",
      "nameEca": "Lichtgenossenschaft Neukirchen eGen",
      "ecn": "AT004120",
      "name": "Lichtgenossenschaft Neukirchen eGen"
    },
    {
      "zip": "4624",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4625",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4650",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4651",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4671",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4672",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4690",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4691",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4692",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4693",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4800",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4840",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4841",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4846",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4901",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4902",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4903",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "4904",
      "nameEca": "Kraftwerk Glatzing-Rüstorf eGen",
      "ecn": "AT003510",
      "name": "Kraftwerk Glatzing-Rüstorf eGen"
    },
    {
      "zip": "8570",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8572",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8580",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8582",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8583",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8591",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8592",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "8593",
      "nameEca": "Stadtwerke Köflach GmbH",
      "ecn": "AT008180",
      "name": "Stadtwerke Köflach"
    },
    {
      "zip": "9911",
      "nameEca": "Elektrowerk Assling, registrierte Genossenschaft mit beschränkter Haftung",
      "ecn": "AT005490",
      "name": "Elektrowerk Assling reg. Gen. m. b. H."
    },
    {
      "zip": "3300",
      "nameEca": "Stadtwerke Amstetten",
      "ecn": "AT002110",
      "name": "Stadtwerke Amstetten GmbH"
    },
    {
      "zip": "8712",
      "nameEca": "EVU der Marktgemeinde Niklasdorf",
      "ecn": "AT008330",
      "name": "EVU der Marktgemeinde Niklasdorf"
    },
    {
      "zip": "2680",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8680",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8682",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8684",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8685",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8691",
      "nameEca": "Stadtwerke Mürzzuschlag Ges.m.b.H.",
      "ecn": "AT008190",
      "name": "Stadtwerke Mürzzuschlag GmbH"
    },
    {
      "zip": "8812",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8833",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8841",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8842",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8843",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8844",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8853",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "8854",
      "nameEca": "Elektrowerk Schöder GmbH",
      "ecn": "AT008720",
      "name": "Elektrowerk Schöder GmbH"
    },
    {
      "zip": "3293",
      "nameEca": "Forstverwaltung Seehof GmbH",
      "ecn": "AT002280",
      "name": "Forstverwaltung Seehof GmbH"
    },
    {
      "zip": "8271",
      "nameEca": "Ing.Peter Böhm, Inhaber der nicht prot. Fa. \"E-Werk Piwetz\"",
      "ecn": "AT008950",
      "name": "E-Werk Piwetz"
    },
    {
      "zip": "2434",
      "nameEca": "Heinrich Polsterer & Mitgesellschafter GesnbR",
      "ecn": "AT002400",
      "name": "Heinrich Polsterer und Mitges GesnbR"
    },
    {
      "zip": "8423",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8424",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8430",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8431",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8434",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8435",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8461",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8471",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "8472",
      "nameEca": "E-Werk Ebner GesmbH",
      "ecn": "AT008730",
      "name": "E-Werk Ebner GesmbH"
    },
    {
      "zip": "4600",
      "nameEca": "eww ag",
      "ecn": "AT003300",
      "name": "eww ag"
    },
    {
      "zip": "4611",
      "nameEca": "eww ag",
      "ecn": "AT003300",
      "name": "eww ag"
    },
    {
      "zip": "4614",
      "nameEca": "eww ag",
      "ecn": "AT003300",
      "name": "eww ag"
    },
    {
      "zip": "4623",
      "nameEca": "eww ag",
      "ecn": "AT003300",
      "name": "eww ag"
    },
    {
      "zip": "4641",
      "nameEca": "eww ag",
      "ecn": "AT003300",
      "name": "eww ag"
    },
    {
      "zip": "8600",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8605",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8642",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8650",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8661",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8662",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "8670",
      "nameEca": "Stadtwerke Kapfenberg GmbH",
      "ecn": "AT008170",
      "name": "Stadtwerke Kapfenberg GmbH"
    },
    {
      "zip": "6123",
      "nameEca": "Stadtwerke Schwaz GmbH",
      "ecn": "AT005150",
      "name": "Stadtwerke Schwaz GmbH"
    },
    {
      "zip": "6130",
      "nameEca": "Stadtwerke Schwaz GmbH",
      "ecn": "AT005150",
      "name": "Stadtwerke Schwaz GmbH"
    },
    {
      "zip": "6134",
      "nameEca": "Stadtwerke Schwaz GmbH",
      "ecn": "AT005150",
      "name": "Stadtwerke Schwaz GmbH"
    },
    {
      "zip": "6136",
      "nameEca": "Stadtwerke Schwaz GmbH",
      "ecn": "AT005150",
      "name": "Stadtwerke Schwaz GmbH"
    },
    {
      "zip": "3293",
      "nameEca": "Licht- und Kraftstromvertrieb der Marktgemeinde Göstling an der Ybbs",
      "ecn": "AT002120",
      "name": "Licht- und Kraftvertrieb der Marktgemeinde Göstling an der Ybbs"
    },
    {
      "zip": "3344",
      "nameEca": "Licht- und Kraftstromvertrieb der Marktgemeinde Göstling an der Ybbs",
      "ecn": "AT002120",
      "name": "Licht- und Kraftvertrieb der Marktgemeinde Göstling an der Ybbs"
    },
    {
      "zip": "3345",
      "nameEca": "Licht- und Kraftstromvertrieb der Marktgemeinde Göstling an der Ybbs",
      "ecn": "AT002120",
      "name": "Licht- und Kraftvertrieb der Marktgemeinde Göstling an der Ybbs"
    },
    {
      "zip": "6450",
      "nameEca": "Wasserkraft Sölden eGen",
      "ecn": "AT005610",
      "name": "Wasserkraft Sölden eGen mbH"
    },
    {
      "zip": "8800",
      "nameEca": "E-Werk der Marktgemeinde Unzmarkt-Frauenberg",
      "ecn": "AT008410",
      "name": "EVU der Marktgemeinde Unzmarkt-Frauenburg"
    },
    {
      "zip": "4184",
      "nameEca": "Reverterasches Elektrizitätswerk",
      "ecn": "AT003540",
      "name": "Revertera'sches Elektrizitätswerk"
    },
    {
      "zip": "4562",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "4643",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "4644",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "4645",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "4655",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "4656",
      "nameEca": "K.u.F. Drack GmbH & Co KG",
      "ecn": "AT003520",
      "name": "K.u.F. Drack GmbH & Co KG"
    },
    {
      "zip": "6074",
      "nameEca": "Kommunalbetriebe Rinn GmbH",
      "ecn": "AT005650",
      "name": "Kommunalbetriebe Rinn GmbH"
    },
    {
      "zip": "6075",
      "nameEca": "Kommunalbetriebe Rinn GmbH",
      "ecn": "AT005650",
      "name": "Kommunalbetriebe Rinn GmbH"
    },
    {
      "zip": "8020",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8045",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8046",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8051",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8052",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8151",
      "nameEca": "E-Werk Gösting Stromversorgungs GmbH",
      "ecn": "AT008210",
      "name": "E-WERK GÖSTING STROMVERSORGUNGS GmbH"
    },
    {
      "zip": "8793",
      "nameEca": "Stadtwerke Trofaiach Gesellschaft m.b.H.",
      "ecn": "AT008490",
      "name": "Stadtwerke Trofaiach Ges.m.b.H"
    },
    {
      "zip": "8794",
      "nameEca": "Stadtwerke Trofaiach Gesellschaft m.b.H.",
      "ecn": "AT008490",
      "name": "Stadtwerke Trofaiach Ges.m.b.H"
    },
    {
      "zip": "8082",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8083",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8323",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8324",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8330",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8332",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8341",
      "nameEca": "Kiendler Vulkanland Strom GmbH",
      "ecn": "AT008580",
      "name": "Kiendler Vulkanlandstrom GmbH"
    },
    {
      "zip": "8010",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8020",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8036",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8041",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8043",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8045",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8047",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8051",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8052",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8053",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8054",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8055",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "8073",
      "nameEca": "Stromnetz Graz GmbH & Co KG",
      "ecn": "AT008100",
      "name": "Stromnetz Graz GmbH & Co KG"
    },
    {
      "zip": "3253",
      "nameEca": "Anton Kittel Mühle Plaika GmbH",
      "ecn": "AT002220",
      "name": "Anton Kittel Mühle Plaika GmbH"
    },
    {
      "zip": "3254",
      "nameEca": "Anton Kittel Mühle Plaika GmbH",
      "ecn": "AT002220",
      "name": "Anton Kittel Mühle Plaika GmbH"
    },
    {
      "zip": "4020",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4030",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4040",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4048",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4050",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4052",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4053",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4055",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4060",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4061",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4062",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4072",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4073",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4100",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4111",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4180",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4181",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4190",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4192",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4193",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4201",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4202",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4203",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4204",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4209",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4210",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4211",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4212",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4213",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4221",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4222",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4223",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4224",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4225",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4230",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4231",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4232",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4240",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4242",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4251",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4252",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4261",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4262",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4263",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4264",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4271",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4272",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4273",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4274",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4280",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4281",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4282",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4283",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4284",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4291",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4292",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4293",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4294",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4310",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4311",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4312",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4320",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4322",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4323",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4324",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4331",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4332",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4341",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4342",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4343",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4351",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4352",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4360",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4362",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4363",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4364",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4371",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4372",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4381",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4382",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4391",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4392",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4470",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4481",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "4613",
      "nameEca": "LINZ NETZ GmbH",
      "ecn": "AT003100",
      "name": "LINZ NETZ GmbH"
    },
    {
      "zip": "2852",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "2871",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "7421",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "7572",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8010",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8020",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8036",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8041",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8042",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8043",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8044",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8045",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8046",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8047",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8051",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8052",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8053",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8054",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8055",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8061",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8062",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8063",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8071",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8072",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8073",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8074",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8075",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8076",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8077",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8081",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8082",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8083",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8091",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8092",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8093",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8101",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8102",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8103",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8111",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8112",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8113",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8114",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8120",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8121",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8122",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8124",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8130",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8131",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8132",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8141",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8142",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8143",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8144",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8151",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8152",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8153",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8160",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8162",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8163",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8171",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8172",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8181",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8182",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8183",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8184",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8190",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8191",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8192",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8200",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8211",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8212",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8221",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8222",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8223",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8224",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8225",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8230",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8232",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8233",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8234",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8240",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8241",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8242",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8243",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8244",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8250",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8251",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8252",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8253",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8254",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8255",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8261",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8262",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8263",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8264",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8265",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8271",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8272",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8273",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8274",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8280",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8282",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8283",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8291",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8292",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8293",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8294",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8295",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8301",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8302",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8311",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8312",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8313",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8321",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8322",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8323",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8324",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8330",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8332",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8333",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8334",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8341",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8342",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8343",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8344",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8345",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8350",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8352",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8353",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8354",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8355",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8361",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8362",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8380",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8385",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8401",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8402",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8403",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8410",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8411",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8412",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8413",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8421",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8422",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8423",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8424",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8430",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8431",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8434",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8435",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8441",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8442",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8443",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8444",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8451",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8452",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8453",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8454",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8455",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8461",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8462",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8463",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8472",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8473",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8480",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8481",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8482",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8483",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8484",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8490",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8492",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8493",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8501",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8502",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8503",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8504",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8505",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8510",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8511",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8521",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8522",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8523",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8524",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8530",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8541",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8542",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8543",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8544",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8551",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8552",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8553",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8554",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8561",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8562",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8563",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8564",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8565",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8570",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8572",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8573",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8580",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8582",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8583",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8584",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8591",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8592",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8593",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8600",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8605",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8611",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8612",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8614",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8616",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8621",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8622",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8623",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8624",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8625",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8632",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8634",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8635",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8636",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8641",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8642",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8643",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8644",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8650",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8652",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8653",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8654",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8661",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8662",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8663",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8664",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8665",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8670",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8671",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8672",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8673",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8674",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8680",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8682",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8684",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8685",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8691",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8692",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8693",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8700",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8712",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8713",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8714",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8715",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8720",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8723",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8724",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8731",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8732",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8733",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8734",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8740",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8741",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8742",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8750",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8753",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8754",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8755",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8756",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8761",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8762",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8763",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8764",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8765",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8770",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8772",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8773",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8774",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8775",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8781",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8782",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8783",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8784",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8785",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8786",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8790",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8792",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8793",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8794",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8795",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8800",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8811",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8812",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8813",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8820",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8822",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8831",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8832",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8833",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8841",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8842",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8843",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8844",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8850",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8852",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8853",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8854",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8861",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8862",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8863",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8900",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8903",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8904",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8911",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8912",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8913",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8920",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8921",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8922",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8923",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8924",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8931",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8932",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8933",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8934",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8940",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8942",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8943",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8950",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8951",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8952",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8953",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8954",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8960",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8961",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8962",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8965",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8966",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8967",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8970",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8971",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8972",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8973",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8974",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8982",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "8983",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "9323",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "9451",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "9463",
      "nameEca": "Energienetze Steiermark GmbH",
      "ecn": "AT008000",
      "name": "Energienetze Steiermark GmbH"
    },
    {
      "zip": "3293",
      "nameEca": "E-Werk Schwaighofer GmbH",
      "ecn": "AT002250",
      "name": "E-Werk Schwaighofer GmbH"
    },
    {
      "zip": "4251",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4252",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4272",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4273",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4274",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4280",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4281",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4282",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4283",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4284",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4292",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4293",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4294",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4362",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4363",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4364",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4371",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4372",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4392",
      "nameEca": "Ebner Strom GmbH",
      "ecn": "AT003460",
      "name": "EBNER STROM GmbH"
    },
    {
      "zip": "4161",
      "nameEca": "EVU Gerald Mathe e.U.",
      "ecn": "AT003570",
      "name": "EVU Mathe Gerald e.U."
    },
    {
      "zip": "4163",
      "nameEca": "EVU Gerald Mathe e.U.",
      "ecn": "AT003570",
      "name": "EVU Mathe Gerald e.U."
    },
    {
      "zip": "3370",
      "nameEca": "wüsterstrom E-Werk GmbH",
      "ecn": "AT002230",
      "name": "wüsterstrom E-Werk GmbH"
    },
    {
      "zip": "3371",
      "nameEca": "wüsterstrom E-Werk GmbH",
      "ecn": "AT002230",
      "name": "wüsterstrom E-Werk GmbH"
    },
    {
      "zip": "3376",
      "nameEca": "wüsterstrom E-Werk GmbH",
      "ecn": "AT002230",
      "name": "wüsterstrom E-Werk GmbH"
    },
    {
      "zip": "8641",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8642",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8643",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8644",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8650",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8652",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8653",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8661",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8662",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8670",
      "nameEca": "Elektrizitätswerk der Stadtgemeinde Kindberg",
      "ecn": "AT008110",
      "name": "Elektrizitätswerk der Stadtgemeinde Kindberg"
    },
    {
      "zip": "8812",
      "nameEca": "Marktgemeinde Neumarkt Versorgungsbetriebsges.m.b.H.",
      "ecn": "AT008420",
      "name": "Marktgemeinde Neumarkt Versorgungsbetriebsgesellschaft m.b.H."
    },
    {
      "zip": "8820",
      "nameEca": "Marktgemeinde Neumarkt Versorgungsbetriebsges.m.b.H.",
      "ecn": "AT008420",
      "name": "Marktgemeinde Neumarkt Versorgungsbetriebsgesellschaft m.b.H."
    },
    {
      "zip": "8822",
      "nameEca": "Marktgemeinde Neumarkt Versorgungsbetriebsges.m.b.H.",
      "ecn": "AT008420",
      "name": "Marktgemeinde Neumarkt Versorgungsbetriebsgesellschaft m.b.H."
    },
    {
      "zip": "9323",
      "nameEca": "Marktgemeinde Neumarkt Versorgungsbetriebsges.m.b.H.",
      "ecn": "AT008420",
      "name": "Marktgemeinde Neumarkt Versorgungsbetriebsgesellschaft m.b.H."
    },
    {
      "zip": "8480",
      "nameEca": "Stadtgemeinde Mureck, Inhaberin der nicht prot. Fa. \"EVU der Stadtgemeinde Mureck\"",
      "ecn": "AT008360",
      "name": "EVU der Stadtgemeinde Mureck"
    },
    {
      "zip": "6361",
      "nameEca": "Kommunalbetriebe Hopfgarten GmbH",
      "ecn": "AT005330",
      "name": "Kommunalbetriebe Hopfgarten GmbH"
    },
    {
      "zip": "4382",
      "nameEca": "E-Werk Sarmingstein Ing. H. Engelmann & Co KG",
      "ecn": "AT002900",
      "name": "E-Werk Sarmingstein Ing. H. Engelmann & Co KG"
    },
    {
      "zip": "4342",
      "nameEca": "Elektrizitätswerk Clam Carl-Philip Clam-Martinic e.U.",
      "ecn": "AT002910",
      "name": "Elektrizitätswerk Clam, Carl Philip Clam Martinic e.U,"
    },
    {
      "zip": "4351",
      "nameEca": "Elektrizitätswerk Clam Carl-Philip Clam-Martinic e.U.",
      "ecn": "AT002910",
      "name": "Elektrizitätswerk Clam, Carl Philip Clam Martinic e.U,"
    },
    {
      "zip": "4352",
      "nameEca": "Elektrizitätswerk Clam Carl-Philip Clam-Martinic e.U.",
      "ecn": "AT002910",
      "name": "Elektrizitätswerk Clam, Carl Philip Clam Martinic e.U,"
    },
    {
      "zip": "8990",
      "nameEca": "Schwarz, Wagendorffer & Co, Elektrizitätswerk GmbH",
      "ecn": "AT008850",
      "name": "Schwarz, Wagendorffer & Co"
    },
    {
      "zip": "8212",
      "nameEca": "Gertraud Schafler GmbH",
      "ecn": "AT008690",
      "name": "Gertraud Schafler GmbH."
    },
    {
      "zip": "8261",
      "nameEca": "Gertraud Schafler GmbH",
      "ecn": "AT008690",
      "name": "Gertraud Schafler GmbH."
    },
    {
      "zip": "8262",
      "nameEca": "Gertraud Schafler GmbH",
      "ecn": "AT008690",
      "name": "Gertraud Schafler GmbH."
    },
    {
      "zip": "8265",
      "nameEca": "Gertraud Schafler GmbH",
      "ecn": "AT008690",
      "name": "Gertraud Schafler GmbH."
    },
    {
      "zip": "8921",
      "nameEca": "Klausbauer Wasser Kraft GesmbH. & Co KG",
      "ecn": "AT008250",
      "name": "Klausbauer Wasser Kraft GesmbH. & Co KG"
    },
    {
      "zip": "8931",
      "nameEca": "Klausbauer Wasser Kraft GesmbH. & Co KG",
      "ecn": "AT008250",
      "name": "Klausbauer Wasser Kraft GesmbH. & Co KG"
    },
    {
      "zip": "9951",
      "nameEca": "Anton Kittel Mühle Plaika GmbH (Tirol)",
      "ecn": "AT005550",
      "name": "Anton Kittel Mühle Plaika GmbH"
    },
    {
      "zip": "9954",
      "nameEca": "Anton Kittel Mühle Plaika GmbH (Tirol)",
      "ecn": "AT005550",
      "name": "Anton Kittel Mühle Plaika GmbH"
    },
    {
      "zip": "4121",
      "nameEca": "E-Werk Altenfelden GmbH",
      "ecn": "AT003900",
      "name": "E-Werk Altenfelden GmbH"
    },
    {
      "zip": "4132",
      "nameEca": "E-Werk Altenfelden GmbH",
      "ecn": "AT003900",
      "name": "E-Werk Altenfelden GmbH"
    },
    {
      "zip": "4152",
      "nameEca": "E-Werk Altenfelden GmbH",
      "ecn": "AT003900",
      "name": "E-Werk Altenfelden GmbH"
    }
  ];
